import { useEffect, useMemo, useRef } from 'react'
import {
  buildExternalLinksFuseIndex,
  searchExternalLinks,
} from '../local/externalLinksRegistry'

/**
 * Headless additive search provider for manually curated external / help URLs.
 *
 * Implements the universal provider interface defined in
 * `src/readmes/SEARCH_ARCHITECTURE.md`. The orchestrator renders this as a
 * sibling of the display provider; results are routed to
 * SupplementarySearchContext under providerId='external-help'.
 *
 * No Redux access — the registry is a static module-level constant, and the
 * Fuse index is built lazily and cached for the lifetime of the page.
 *
 * Each emitted hit shape:
 *   { id, label, url, icon, terms,
 *     objectID, __external: true, __localOrigin: true }
 *
 * The UI is expected to discriminate via __external and route via
 * window.open(url, '_blank', 'noopener,noreferrer').
 */
function ExternalLinksSearchProvider({ query, options, onResults }) {
  const fuse = useMemo(() => buildExternalLinksFuseIndex(), [])

  const onResultsRef = useRef(onResults)
  onResultsRef.current = onResults

  useEffect(() => {
    if (!query) {
      onResultsRef.current({ hits: [] })
      return
    }
    const limit = options && options.hitsPerPage ? options.hitsPerPage : 6
    const hits = searchExternalLinks(fuse, query, limit)
    onResultsRef.current({ hits })
    // eslint-disable-next-line no-console
    console.log('[local-search:external-help]', {
      query, limit, hitCount: hits.length, hits,
    })
  }, [query, fuse, options])

  return null
}

export default ExternalLinksSearchProvider
